import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticateService } from '../services/authenticate.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
  constructor(
    private router: Router,
    private auth: AuthenticateService
  ){

  }
  async canActivate(){
      const isUserLoggedIn = await this.auth.validarToken();
      if(isUserLoggedIn){
        return true;
      }
      else{
        this.router.navigate(['login']);
      }
      return true;
  }

}
